import { Dialog } from '@capacitor/dialog';

export default async function confirm(message, confirmCallback=function(){}, title='Confirm', buttonLabels=['OK', 'Cancel']) {
  const { value } = await Dialog.confirm({
    title: title,
    message: message,
    okButtonTitle: buttonLabels[0],
    cancelButtonTitle: buttonLabels[1],
  });

  confirmCallback(value ? 1 : 0);
}
